import React from 'react';

const SvgIcContractIcon = props => {
  const {
    color,
    stroke,
    fill,
    strokeWidth = 1.5,
    size,
    width,
    height,
    fontSize,
    ...otherProps
  } = props;

  // Usa color, stroke o fill para determinar el color final
  const finalColor = color || stroke || fill || '#104eb2';

  return (
    <svg
      id="icon__doc_pen_icon_1"
      width={width || size || 66.598}
      height={height || size || 65.488}
      viewBox="0 0 66.598 65.488"
      xmlSpace="preserve"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ fontSize }}
      {...otherProps}
    >
      {/* Contorno del documento */}
      <rect
        x="1.11"
        y="1.11"
        width="47.729"
        height="62.158"
        fill="none"
        stroke={finalColor}
        strokeWidth={strokeWidth}
      />

      {/* Líneas de texto como líneas simples */}
      <line
        x1="19.979"
        y1="12.21"
        x2="31.079"
        y2="12.21"
        stroke={finalColor}
        strokeWidth={strokeWidth}
      />
      <line
        x1="9.99"
        y1="25.529"
        x2="16.65"
        y2="25.529"
        stroke={finalColor}
        strokeWidth={strokeWidth}
      />
      <line
        x1="21.089"
        y1="25.529"
        x2="45.508"
        y2="25.529"
        stroke={finalColor}
        strokeWidth={strokeWidth}
      />
      <line
        x1="5.55"
        y1="29.969"
        x2="45.509"
        y2="29.969"
        stroke={finalColor}
        strokeWidth={strokeWidth}
      />
      <line
        x1="5.55"
        y1="34.409"
        x2="34.409"
        y2="34.409"
        stroke={finalColor}
        strokeWidth={strokeWidth}
      />
      <line
        x1="38.849"
        y1="34.409"
        x2="45.509"
        y2="34.409"
        stroke={finalColor}
        strokeWidth={strokeWidth}
      />
      <line
        x1="25.529"
        y1="38.849"
        x2="45.508"
        y2="38.849"
        stroke={finalColor}
        strokeWidth={strokeWidth}
      />
      <line
        x1="5.55"
        y1="38.849"
        x2="21.09"
        y2="38.849"
        stroke={finalColor}
        strokeWidth={strokeWidth}
      />
      <line
        x1="41.069"
        y1="43.289"
        x2="45.509"
        y2="43.289"
        stroke={finalColor}
        strokeWidth={strokeWidth}
      />
      <line
        x1="5.55"
        y1="43.289"
        x2="11.1"
        y2="43.289"
        stroke={finalColor}
        strokeWidth={strokeWidth}
      />
      <line
        x1="15.54"
        y1="43.289"
        x2="36.63"
        y2="43.289"
        stroke={finalColor}
        strokeWidth={strokeWidth}
      />
      <line
        x1="28.859"
        y1="56.608"
        x2="44.399"
        y2="56.608"
        stroke={finalColor}
        strokeWidth={strokeWidth}
      />
      <line
        x1="15.54"
        y1="7.77"
        x2="35.519"
        y2="7.77"
        stroke={finalColor}
        strokeWidth={strokeWidth}
      />
      <line
        x1="32.189"
        y1="18.87"
        x2="45.509"
        y2="18.87"
        stroke={finalColor}
        strokeWidth={strokeWidth}
      />
      <line
        x1="5.55"
        y1="47.729"
        x2="29.969"
        y2="47.729"
        stroke={finalColor}
        strokeWidth={strokeWidth}
      />

      {/* Pluma */}
      <g data-name="Group 522">
        <g data-name="Group 521">
          <path
            data-name="Path 505"
            d="M65.488 9.99h-3.33a4.44 4.44 0 10-8.88 0v39.96a11.747 11.747 0 003.465 8.365l.19.19a1.11 1.11 0 001.569 0l.19-.19a11.747 11.747 0 003.465-8.365V12.21h2.22v9.99h2.22V11.1a1.11 1.11 0 00-1.109-1.11zm-7.77 46.1a9.518 9.518 0 01-2.157-5.035h4.318a9.518 9.518 0 01-2.16 5.039zm2.22-7.255h-4.44V12.21h4.44zM55.499 9.99a2.22 2.22 0 014.44 0z"
            fill={finalColor}
            stroke="none"
          />
        </g>
      </g>
    </svg>
  );
};

export default SvgIcContractIcon;
